import {
  useUserCtxSelector,
  useManagerCtxSelector,
} from '../xstate/app.xstate';

export enum OrganizationRoleNames {
  SUPER_ADMIN = 'Super Admin',
  ADMIN = 'Organization Admin',
  MANAGER = 'Organization Manager',
}

export const useAuthRole = (authRoles: string[]) => {
  const { currentUser } = useUserCtxSelector((ctx) => ({
    currentUser: ctx.user,
  }));
  const { selectedOrgId } = useManagerCtxSelector((ctx) => ({
    selectedOrgId: ctx.selectedOrgId,
  }));

  // Consolidate all roles (both team-based and directly assigned) in a single operation
  const allUserRoles = [
    // Roles assigned through teams
    ...(currentUser?.assignedTeams?.flatMap(
      ({ assignedRoles, defaultAccount }) => {
        if (
          defaultAccount?.id === selectedOrgId ||
          defaultAccount?.allChildAccounts
            ?.map(({ id }) => id)
            ?.includes(selectedOrgId!)
        )
          return assignedRoles?.map(({ id, name }) => ({
            label: name,
            value: id,
          }));

        return [];
      }
    ) || []),

    // Directly assigned roles
    ...(currentUser?.assignedRoles?.map(({ name, id }) => ({
      label: name,
      value: id,
    })) || []),
  ];

  return allUserRoles.some((role) => authRoles.includes(role?.label as string));
};
